import { render, staticRenderFns } from "./NonconformanceHoldTagsForm.vue?vue&type=template&id=87365dc6"
import script from "./NonconformanceHoldTagsForm.vue?vue&type=script&lang=js"
export * from "./NonconformanceHoldTagsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports